define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'internal_util/ClientUtil',
	'model/EidClient',
	'model/AuthenticationOption',
	'model/AuthenticationOptionGroup',
	'amdi18n-loader?!model/eidclient/nls/TR03124Client_strings'
], function (
	Logger,
	Util,
	Configuration,
	ClientUtil,
	EidClient,
	AuthenticationOption,
	AuthenticationOptionGroup,
	Strings
) {
	'use strict';

	function TR03124Client() {
		var _id = 'http://ws.skidentity.de/oi/go/client/TR03124Client',
			_name = 'TR03124Client',
			_baseAddress = 'http://127.0.0.1:24727/eID-Client?',
			_enabled = false;

		EidClient.call(this, _id);


		// private methods

		function log(method, message, data) {
			Logger.log(_name, method, message, data);
		}


		// public methods

		this.name = function () {
			return _name;
		};

		this.supportsPlatform = function () {
			return !ClientUtil.isMobileClient();
		};

		this.supportsAuthenticationOption = function (authenticationOption) {
			return true;
		};

		this.supportsStatus = function () {
			return false;
		};

		this.enableDetection = function () {
			_enabled = true;
		};

		this.disableDetection = function () {
			_enabled = false;
		};

		this.detect = function (callbacks, errorCallbacks) {
			var _name = 'detect';

			log(_name, Strings.detection_started);

			if (_enabled) {
				log(_name, Strings.detection_successful, _enabled);
				Util.callCallbacks(callbacks);
			} else {
				log(_name, Strings.detection_failed, _enabled);
				Util.callCallbacks(errorCallbacks);
			}
		};

		this.start = function () {
			// Nothing to do here
		};

		this.stop = function () {
			// Nothing to do here
		};

		this.activate = function (authenticationOption, tcTokenURL, callbacks) {
			var eidClientUrl = _baseAddress,
				authenticationOptions,
				i;

			if (authenticationOption instanceof AuthenticationOptionGroup) {
				authenticationOptions = authenticationOption.authenticationOptions();

				eidClientUrl += 'cardTypes=';

				for (i = 0; i < authenticationOptions.length; i++) {
					if (i > 0) {
						eidClientUrl += ',';
					}

					eidClientUrl += encodeURIComponent(authenticationOptions[i].type())
				}
			} else {
				eidClientUrl += 'cardType=' + encodeURIComponent(authenticationOption.type());
			}

			eidClientUrl += '&tcTokenURL=' + encodeURIComponent(tcTokenURL);

			Util.callCallbacks(callbacks);
			ClientUtil.redirectTo(eidClientUrl);
		};

		this.toObject = function () {
			return _name;
		};
	}

	TR03124Client.prototype = Object.create(EidClient.prototype);

	return TR03124Client;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/eidclient/TR03124Client.js
// module id = 279
// module chunks = 3